import { z } from "zod";

export const refineTimes = (start: TimeType, end: TimeType): boolean => {
  const startDate = new Date();
  const endDate = new Date();
  startDate.setHours(start.hour, start.minute, 0, 0);
  endDate.setHours(end.hour, end.minute, 0, 0);
  return startDate < endDate;
};

export const timeSchema = z.object({
  hour: z.number(),
  minute: z.number(),
});

export type TimeType = z.infer<typeof timeSchema>;

export const detailledDateSchema = z
  .object({
    day: z.string(),
    start: timeSchema,
    end: timeSchema,
    isFullDay: z.boolean().nullish().default(null).optional(),
  })
  .refine((data) => data.isFullDay || refineTimes(data.start, data.end), {
    message: "L'heure de début doit être antérieure à l'heure de fin",
    path: ["start"],
  });

export type DetailledDateType = z.infer<typeof detailledDateSchema>;
